import React from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import Navigation from './Navigation.jsx';

const LeftSidebar = ({ isOpen, toggle, currentPage, setCurrentPage }) => {
  return (
    <>
      {/* MOBILE OVERLAY */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={toggle}
      />

      {/* SIDEBAR */}
      <aside
        className={`fixed lg:sticky top-0 left-0 h-screen bg-surface backdrop-blur-sm border-r border-subtle z-50 transition-all duration-300 ${
          isOpen ? 'translate-x-0 lg:w-64' : '-translate-x-full lg:translate-x-0 lg:w-0'
        }`}
      >
        {/* CONTENT WRAPPER */}
        <div className={`${isOpen ? 'block' : 'hidden lg:hidden'} w-64`}>

          {/* MOBILE HEADER */}
          <div className="flex items-center justify-between p-4 border-b border-subtle lg:hidden">
            <span className="accent-amber font-bold">Menu</span>
            <button
              onClick={toggle}
              className="accent-amber hover:text-primary transition-colors"
            >
              <X size={20} />
            </button>
          </div>

          {/* NAVIGATION (Handles Submenus + Routing) */}
          <Navigation
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onClose={() => {
              // Auto close sidebar on mobile after navigation
              if (window.innerWidth < 1024) toggle();
            }}
          />
        </div>

        {/* DESKTOP COLLAPSE BUTTON */}
        <button
          onClick={toggle}
          className="hidden lg:flex absolute -right-6 top-20 bg-surface border border-subtle p-1 rounded-r accent-amber hover:bg-surface-elevated transition-colors"
          title={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        >
          {isOpen ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
        </button>
      </aside>
    </>
  );
};

export default LeftSidebar;
